import React, { Component } from "react";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import { formatDate } from "../../../Utils/format-date.js";
import axios from "axios";
import addAccessTokenToUrl from "../../../Utils/Axios/addTokenToUrl";
import Worksheet from "./Goal-Setting-Worksheets";
import ResponsiveWorksheet from "./Responsive/Goal-Setting-Worksheets";
import NavBar from "../../../Components/NavBar/Navbar";
import Sidebar from "../../../Components/Sidebar/sidebar";
import ResponsiveSidebar from "../../../Components/Sidebar/Responsive/SideBar";
import { withRouter } from "react-router";

const calcWidth = window.innerWidth;
export class MyWorksheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[0].id,
      sidebarOpen: false,
      enableNotification: false,
      collapseID: null,
      createModal: false,
      editModal: false,
      resp: [],
      date: "",
      orientation: "",
      name: "",
      options: "all",
      noData: false,
    };
  }
  componentDidMount() {
    /* get the user id from the url using params */
    const getUserId = this.props.match.params.id;
    // dashboard edit goal setting api
    axios
      .get(
        addAccessTokenToUrl(
          `/assessments/goal-setting/worksheets/list/${getUserId}/`
        )
      )
      .then((response) => {
        this.setState({
          resp: response.data.worksheet_list,
          noData: false,
        });
      })
      .catch((error) => {
        this.setState({
          noData: true,
        });
      });
  }

  handleSelectOption = (selectOptions) => {
    this.setState({
      options: selectOptions,
    });
  };
  handleSearchInput = (inputValue) => {
    const getUserId = this.props.match.params.id;
    /* convert the input type value to lowercase */
    const getInputValue = inputValue.toLowerCase();
    axios
      .get(
        addAccessTokenToUrl(
          `/assessments/goal-setting/worksheets/list/${getUserId}/`
        )
      )
      .then((response) => {
        /* add an empty array to store the new filtered array */
        const newResult = [];
        /* compare the string stored inside the option state and execute the filter function accordingly */
        if (this.state.options == "all") {
          response.data.worksheet_list.filter((workSheetName) => {
            if (
              workSheetName.worksheet_name
                .toLowerCase()
                .includes(getInputValue) ||
              workSheetName.orientation__orientation_name
                .toLowerCase()
                .includes(getInputValue) ||
              formatDate(workSheetName.assessment__created)
                .toLowerCase()
                .includes(getInputValue)
            ) {
              newResult.push(workSheetName);
            }
          });
          this.setState({
            resp: newResult,
            noData: false,
          });
        } else if (this.state.options == "worksheet name") {
          response.data.worksheet_list.filter((workSheetName) => {
            if (
              workSheetName.worksheet_name.toLowerCase().includes(getInputValue)
            ) {
              newResult.push(workSheetName);
            }
          });
          this.setState({
            resp: newResult,
            noData: false,
          });
        } else if (this.state.options == "orientation") {
          response.data.worksheet_list.filter((orientationName) => {
            if (
              orientationName.orientation__orientation_name
                .toLowerCase()
                .includes(getInputValue)
            ) {
              newResult.push(orientationName);
            }
          });
          this.setState({
            resp: newResult,
          });
        } else if (this.state.options == "assessment date") {
          response.data.worksheet_list.filter((assessmentDate) => {
            if (
              formatDate(assessmentDate.assessment__created)
                .toLowerCase()
                .includes(getInputValue)
            ) {
              newResult.push(assessmentDate);
            }
          });
          this.setState({
            resp: newResult,
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  handleCreateModal = (day) => {
    this.setState({
      createModal: true,
      date: day,
    });
  };

  handleEditModal = (name, orientation, day) => {
    
    this.setState({
      editModal: true,
      name: name,
      orientation: orientation,
      date: day,
    });
  };

  handleModalClose = () => {
    this.setState({
      createModal: false,
      editModal: false,
    });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  toggleCollapse = (collapseID) => {
    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };

  handleManageWorksheet = (worksheetDetails) => {
    const getOrientationName = worksheetDetails.orientation__orientation_name;
    this.props.history.push({
      pathname: `/new/app/Worksheets/${getOrientationName}`,
    });
  };

  render() {
    return (
      <div>
        <NavBar
          enableNotification={this.state.enableNotification}
          handleNotification={this.handleNotification}
        />
        <Sidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
        />
        <ResponsiveSidebar
          items={SIDE_NAV_ITEMS}
          selectedSideNav={this.state.selectedSideNav}
          sidebarOpen={this.state.sidebarOpen}
          onSetSidebarOpen={this.onSetSidebarOpen}
        />
        {calcWidth <= 767 ? (
          <ResponsiveWorksheet
            collapseID={this.state.collapseID}
            toggleCollapse={this.toggleCollapse}
            handleCreateModal={this.handleCreateModal}
            handleEditModal={this.handleEditModal}
            editModal={this.state.editModal}
            createModal={this.state.createModal}
            handleModalClose={this.handleModalClose}
            resp={this.state.resp}
            date={this.state.date}
            orientation={this.state.orientation}
            name={this.state.name}
            handleManageWorksheet={this.handleManageWorksheet}
            handleSearchInput={this.handleSearchInput}
            handleSelectOption={this.handleSelectOption}
            // noData={this.state.noData}
          />
        ) : (
          <Worksheet
            handleCreateModal={this.handleCreateModal}
            handleEditModal={this.handleEditModal}
            editModal={this.state.editModal}
            createModal={this.state.createModal}
            handleModalClose={this.handleModalClose}
            resp={this.state.resp}
            date={this.state.date}
            orientation={this.state.orientation}
            name={this.state.name}
            handleManageWorksheet={this.handleManageWorksheet}
            handleSearchInput={this.handleSearchInput}
            handleSelectOption={this.handleSelectOption}
            noData={this.state.noData}
          />
        )}
      </div>
    );
  }
}

export default withRouter(MyWorksheet);



// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Goal-Setting-Worksheets/index.jsx